import { Box, Grid, styled } from '@mui/material';

export const RegisterContainer = styled(Grid)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  backgroundColor: theme.palette.background.default,
}));

export const RegisterBanner = styled(Box)(({ theme }) => ({
  height: '100%',
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed',
  backgroundColor: theme.palette.primary.dark,
  backgroundBlendMode: 'multiply',
  position: 'relative',
  '& .logo': {
    width: '10rem',
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    mixBlendMode: 'color-dodge',
  },
}));

export const RegisterFormHeader = styled(Box)(({ theme }) => ({
  userSelect: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
  '& .MuiTypography-overline': {
    color: theme.palette.text.secondary,
  },
  '& img': {
    width: '10rem',
  },
}));

export const StyledRegisterForm = styled('form')(({ theme }) => ({
  minHeight: '100%',
  width: '100%',
  maxWidth: 560,
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.paper,
}));
